import React from "react";
import { Skeleton } from "@mui/material";
import type { RelatedHat } from "../../types";
import {
  CarouselDialog,
  CarouselCard,
  CarouselCardImage,
  CarouselCardOverlay,
  CarouselCardName,
} from "./CarouselDialog";
import { SentimentBadge } from "./SentimentBadge";

interface HatViewMoreDialogProps {
  open: boolean;
  onClose: () => void;
  hats: RelatedHat[];
  onHatClick?: (hatId: string) => void;
  imagesLoading?: boolean;
}

export const HatViewMoreDialog = ({
  open,
  onClose,
  hats,
  onHatClick,
  imagesLoading,
}: HatViewMoreDialogProps) => (
  <CarouselDialog
    open={open}
    onClose={onClose}
    title="Hats You Might Also Like"
  >
    {hats.map((hat) => {
      const imgUrl = hat.hatCard?.mediumSquare;
      return (
        <CarouselCard key={hat.id} onClick={() => onHatClick?.(hat.id)}>
          {imgUrl ? (
            <CarouselCardImage src={imgUrl} alt={hat.displayName} />
          ) : imagesLoading ? (
            <Skeleton
              variant="rounded"
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                borderRadius: "20px",
                bgcolor: "rgba(255, 255, 255, 0.08)",
              }}
            />
          ) : null}
          <CarouselCardOverlay>
            <CarouselCardName>{hat.displayName}</CarouselCardName>
          </CarouselCardOverlay>
          <SentimentBadge sentiment={hat.sentiment} />
        </CarouselCard>
      );
    })}
  </CarouselDialog>
);
